var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid tabs",staticStyle:{"padding":"0"}},[(_vm.showTabs)?_c('manage-tabs'):_vm._e(),_vm._v(" "),_c('router-view',{key:_vm.Inventory})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }